import subchapter1 from './subchapter1'
import subchapter2 from './subchapter2'
import subchapter3 from './subchapter3'
import subchapter4 from './subchapter4'
import subchapter5 from './subchapter5'
import subchapter6 from './subchapter6'
import subchapter7 from './subchapter7'
import subchapter8 from './subchapter8'
import subchapter9 from './subchapter9'

export const chapter1sub1 = subchapter1;
export const chapter1sub2 = subchapter2;
export const chapter1sub3 = subchapter3;
export const chapter1sub4 = subchapter4;
export const chapter1sub5 = subchapter5;
export const chapter1sub6 = subchapter6;
export const chapter1sub7 = subchapter7;
export const chapter1sub8 = subchapter8;
export const chapter1sub9 = subchapter9;